var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.title || "无"))])
          ])
        ]),
        _vm._v(" "),
        _vm.goodsRecvVoucher.orderFlag
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-1-5x" }, [
                _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.orderNo))])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.no))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.buyerRecvAddr))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.receiveTime))])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value  width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.senderComName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value  width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.senderContactName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.senderContactTel))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.driverName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.driverMobile))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(12),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.vehicleLsnNo))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(13),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.goodsRecvVoucher.arriveDelayed
              ? _c("span", [_vm._v("是")])
              : _vm._e(),
            _vm._v(" "),
            !_vm.goodsRecvVoucher.arriveDelayed
              ? _c("span", [_vm._v("否")])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.goodsRecvVoucher.arriveDelayed
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(14),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-1-5x" }, [
                _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.dueArriveDate))])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(15),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.actualArriveDate))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(16),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.goodsRecvVoucher.exceptional
              ? _c("span", [_vm._v("是")])
              : _vm._e(),
            _vm._v(" "),
            !_vm.goodsRecvVoucher.exceptional
              ? _c("span", [_vm._v("否")])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.goodsRecvVoucher.exceptional
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(17),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-1-5x" }, [
                _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.exceptionDesc))])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._m(18),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(19),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.goodsRecvVoucher.totalAmount != null
              ? _c("span", [
                  _vm._v(_vm._s(_vm.goodsRecvVoucher.totalAmount.toFixed(2)))
                ])
              : _c("span", [_vm._v("0.00")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(20),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.goodsRecvVoucher.totalLogisFee != null
              ? _c("span", [
                  _vm._v(_vm._s(_vm.goodsRecvVoucher.totalLogisFee.toFixed(2)))
                ])
              : _c("span", [_vm._v("0.00")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(21),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.goodsRecvVoucher.totalSetupFee != null
              ? _c("span", [
                  _vm._v(_vm._s(_vm.goodsRecvVoucher.totalSetupFee.toFixed(2)))
                ])
              : _c("span", [_vm._v("0.00")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.goodsRecvVoucher.goodsRecvVoucherItemList,
                border: "",
                "tooltip-effect": "dark",
                maxHeight: "400",
                "summary-method": _vm.getGoodsRecvVoucherItemList,
                "show-summary": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "title",
                  label: "商品名称",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "brandName",
                  label: "品牌",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "180",
                  prop: "asmblFlag",
                  label: "需要供应商提供唯一标识码"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.vendorUknoFlag
                          ? _c("span", [_vm._v("是")])
                          : _c("span", [_vm._v("否")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "80",
                  prop: "setupFlag",
                  label: "需要安装"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.setupFlag
                          ? _c("span", [_vm._v("是")])
                          : _c("span", [_vm._v("否")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "80",
                  prop: "asmblFlag",
                  label: "含组装商品"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.asmblFlag
                          ? _c("span", [_vm._v("是")])
                          : _c("span", [_vm._v("否")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "80",
                  prop: "asmblFlag",
                  label: "组装件"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.asmblAccFlag
                          ? _c("span", [_vm._v("是")])
                          : _c("span", [_vm._v("否")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "120",
                  prop: "asmblFlag",
                  label: "安装时完成组装"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.asmblWhileSetup
                          ? _c("span", [_vm._v("是")])
                          : _c("span", [_vm._v("否")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "price",
                  label: "含税价(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.price != null
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.price.toFixed(2)))
                            ])
                          : _c("span", [_vm._v("0.00")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "taxRate",
                  label: "税率(%)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.taxRate != null
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.taxRate.toFixed(2)))
                            ])
                          : _c("span", [_vm._v("0.00")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "taxRate",
                  label: "税额(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (
                                (((rows.row.price || 0) * rows.row.quantity) /
                                  (1 + rows.row.taxRate * 0.01)) *
                                (rows.row.taxRate * 0.01)
                              ).toFixed(2) || 0.0
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "ntxPrice",
                  label: "未税价(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.ntxPrice != null
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.ntxPrice.toFixed(2)))
                            ])
                          : _c("span", [_vm._v("0.00")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "120",
                  prop: "amount",
                  label: "费用小计(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.amount != null
                          ? _c("span", [
                              _vm._v(_vm._s(rows.row.amount.toFixed(2)))
                            ])
                          : _c("span", [_vm._v("0.00")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "shipQuantity",
                  label: "发货数量",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.shipQuantity - scope.row.offsetQuantity
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "surplusQuantity",
                  label: "待收数量",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.shipQuantity -
                                scope.row.offsetQuantity -
                                scope.row.quantity
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "quantity",
                  label: "收货数量",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  width: "140",
                  prop: "batchNo",
                  label: "批次号",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "desc",
                  label: "描述",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "receiptState",
                  width: "100",
                  label: "验收状态"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.receiptStateMap[rows.row.receiptState])
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "receiptDesc",
                  width: "150",
                  label: "验收状态描述",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  width: "150",
                  prop: "eval",
                  label: "操作"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.evalSave(scope.row)
                              }
                            }
                          },
                          [_vm._v("评价")]
                        ),
                        _vm._v(" "),
                        scope.row.ukQuantity > 0
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.showGoodsUkno(scope.row)
                                  }
                                }
                              },
                              [_vm._v("查看商品标识码")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.goodsRecvVoucher.id != null
        ? _c("swb-recv-file-edit", {
            ref: "swb_recv_file_edit",
            attrs: { id: _vm.goodsRecvVoucher.id, edit: false }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("收货信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("发货信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货人联系方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("司机姓名")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("司机电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("车辆牌号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("到货是否有延迟")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("约定到货日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("实际到货日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否有异常情况")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("异常描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("费用信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("商品总费用(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("物流费用(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("安装费用(元)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-105d0de0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-105d0de0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsRecvVoucherInfo.vue
// module id = 2682
// module chunks = 0